// Keep inline search selections inside the same market-circle boundary
// enforced by UniAirLocationPicker's full-screen map.
export const isWithinAirportSearchArea = (point, area) => {
  const latitude = Number(point?.latitude);
  const longitude = Number(point?.longitude);
  const areaLatitude = Number(area?.latitude);
  const areaLongitude = Number(area?.longitude);
  const radiusMetres = Number(area?.radius_metres ?? area?.radiusMetres ?? 0);

  if (![latitude, longitude, areaLatitude, areaLongitude, radiusMetres].every(Number.isFinite)
    || radiusMetres <= 0) return false;

  const toRadians = (value) => (value * Math.PI) / 180;
  const earthRadiusMetres = 6371000;
  const latitudeDifference = toRadians(latitude - areaLatitude);
  const longitudeDifference = toRadians(longitude - areaLongitude);
  const haversine = Math.sin(latitudeDifference / 2) ** 2
    + Math.cos(toRadians(areaLatitude)) * Math.cos(toRadians(latitude))
    * Math.sin(longitudeDifference / 2) ** 2;

  return 2 * earthRadiusMetres * Math.atan2(
    Math.sqrt(haversine),
    Math.sqrt(Math.max(0, 1 - haversine)),
  ) <= radiusMetres;
};

